import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createHead } from '@vueuse/head'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.css'

const app = createApp(App)
const head = createHead()
app.use(router)
app.use(head)

router.isReady().then(() => {
  document.dispatchEvent(new Event('render-event'))
  app.mount('#app')
})
